import React from 'react';
import { prop } from 'ramda';

import Button, { buttonColor, buttonType } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';
import { ACTION } from '../../../../constants';

export default class BoatStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }

  isActionAllowed = action => {
    const { actionsList } = this.props;
    return actionsList.find(act => act === action);
  };

  render() {
    const { canEdit, isFinalReview, performAction, boatDetailsRequestInProcess, boat, user } = this.props;

    if (user.isInspector()) return null;
    if (boatDetailsRequestInProcess) return null;

    const actions = [
      {
        key: 'edit',
        isShown: canEdit,
        Component: () => (
          <EditApplicationButton
            className='_height_40 _width_pc_100 _max_width_180 _margin_right_20'
            onClick={performAction(ACTION.EDIT, boat)}
          />
        ),
      },
      {
        key: 'print',
        isShown: !isFinalReview && this.isActionAllowed(ACTION.PRINT),
        Component: () => (
          <Button
            label='Print'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={performAction(ACTION.PRINT, boat)}
            color={buttonColor.green}
          />
        ),
      },
      {
        key: 'roll',
        isShown: !isFinalReview && this.isActionAllowed(ACTION.ROLL_OVER),
        Component: () => (
          <React.Fragment>
            <Button
              label='Roll Over'
              buttonClassName='_height_40 _width_120 _margin_right_20'
              iconClassName='rollover-icon'
              onClick={performAction(ACTION.ROLL_OVER, boat)}
              color={buttonColor.green}
            />
            {boat.status !== 'DRAFT' && <div className='actions-delimiter' />}
          </React.Fragment>
        ),
      },
      {
        key: 'deactivate',
        isShown: this.isActionAllowed(ACTION.DEACTIVATE),
        Component: () => (
          <Button
            label='Deactivate'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={performAction(ACTION.DEACTIVATE, boat)}
            color={buttonColor.red}
          />
        ),
      },
      {
        key: 'reactivate',
        isShown: this.isActionAllowed(ACTION.REACTIVATE),
        Component: () => (
          <Button
            label='Reactivate'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={performAction(ACTION.REACTIVATE, boat)}
            type={buttonType.primary}
            color={buttonColor.green}
          />
        ),
      },
    ];

    if (actions.filter(prop('isShown')).length === 0) {
      return null;
    }

    return (
      <section className='scene_section detailsScene__change-status-section'>
        <header>Actions</header>
        <div className='detailsScene__change-status-buttons-wrapper'>
          {actions.map(({ key, isShown, Component }) => isShown && <Component key={key} />)}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatStatus.jsx